<template>
  <ul class="list">
    <li class="list__item">
      <Alpha class="list__icon" /> Инфошум и Альфа
    </li>
    <li class="list__item">
      <Podcasts class="list__icon" /> Подкасты
    </li>
    <li class="list__item">
      <Calendar class="list__icon" /> Крипто-календарь
    </li>
    <li class="list__item">
      <Forecasters class="list__icon" /> Лента Форкастеров
    </li>
    <li class="list__item">
      <Signals class="list__icon" /> Сигналы и Идеи
    </li>
    <li class="list__item">
      <Screener class="list__icon" /> Скринер рынка
    </li>
  </ul>
</template>

<script setup>
  import Alpha from './icons/Alpha.vue';
  import Calendar from './icons/Calendar.vue';
  import Forecasters from './icons/Forecasters.vue';
  import Podcasts from './icons/Podcasts.vue';
  import Screener from './icons/Screener.vue';
  import Signals from './icons/Signals.vue';
</script>

<style lang="scss" scoped>
  @import "./styles.scss"
</style>